<template>
    <div
        @click="clickDiv" 
        class="news-holding-date">{{ dateString }}
    </div>
</template>
<script>

import { useEventsStore } from '@/store/events'

export default {
    name: 'NewsHoldingDate',
    props: {
        dateStart: Date,
        dateEnd: Date
    },
    computed:{
        dateString(){
            let month1 = this.dateStart.getMonth()
            let day1 = this.dateStart.getDate().toString()
            let year1 = this.dateStart.getFullYear().toString()
            let month2 = this.dateEnd.getMonth()
            let day2 = this.dateEnd.getDate().toString()
            let year2 = this.dateEnd.getFullYear().toString()
            let monthNames = {
                0:'января',
                1:'февраля',
                2:'марта',
                3:'апреля',
                4:'мая',
                5:'июня',
                6:'июля',
                7:'августа',
                8:'сентября',
                9:'октября',
                10:'ноября',
                11:'декабря'
            }
            let monthName1 = monthNames[month1]
            let monthName2 = monthNames[month2]
            if ( day1 == day2 && month1 == month2 && year1 == year2 )
                return 'Дата события:  ' + day1 + ' ' + monthName1 +' '+ year1 +' г.'
            return 'Дата события:  ' + day1 + ' ' + monthName1 +' '+ year1 +' г. - ' + day2 + ' ' + monthName2 +' '+ year2 +' г.'
        }
    },
    methods:{
        clickDiv(){
            useEventsStore().setDefaultFilters()
            useEventsStore().setSelectedDate(this.dateStart)
            this.$router.push({name: "UpcomingEventsPage", path: '/upcoming_events'})
        }
    }
}
</script>